    <div class="rental-detail" *ngIf="!loading; else spinner">
      <div class="page-header">
        <button mat-icon-button routerLink="/rentals" aria-label="Назад">
          <mat-icon>arrow_back</mat-icon>
        </button>
        <h1 class="page-title">Прокат #{{ rental?.id }}</h1>
      </div>

      <div *ngIf="rental">
        <mat-card class="detail-card">
          <mat-card-content>
            <div class="status-row">
              <span>Статус:</span>
              <mat-chip-set>
                <mat-chip [class]="'status-' + rental.status" selected>
                  {{ rental.status | statusLabel:'rental' }}
                </mat-chip>
              </mat-chip-set>
            </div>

            <mat-list>
              <mat-list-item>
                <mat-icon matListItemIcon>directions_car</mat-icon>
                <span matListItemTitle>Автомобиль</span>
                <span matListItemLine>{{ rental.car_title }}</span>
              </mat-list-item>
              <mat-list-item *ngIf="rental.license_plate !== undefined">
                <mat-icon matListItemIcon>confirmation_number</mat-icon>
                <span matListItemTitle>Госномер</span>
                <span matListItemLine>{{ rental.license_plate || '—' }}</span>
              </mat-list-item>
              <mat-list-item>
                <mat-icon matListItemIcon>person</mat-icon>
                <span matListItemTitle>ФИО</span>
                <app-copy-text
                  matListItemLine
                  [value]="rental.client_name">
                </app-copy-text>
              </mat-list-item>
              <mat-list-item *ngIf="rental.client_phone">
                <mat-icon matListItemIcon>phone</mat-icon>
                <span matListItemTitle>Телефон</span>
                <app-copy-text
                  matListItemLine
                  [value]="rental.client_phone">
                </app-copy-text>
              </mat-list-item>
              <mat-list-item *ngIf="rental.handover_location">
                <mat-icon matListItemIcon>place</mat-icon>
                <span matListItemTitle>Место выдачи</span>
                <span matListItemLine>{{ rental.handover_location }}</span>
              </mat-list-item>
              <mat-list-item *ngIf="rental.handover_datetime">
                <mat-icon matListItemIcon>schedule</mat-icon>
                <span matListItemTitle>Дата/время выдачи</span>
                <span matListItemLine>{{ formatDateTime(rental.handover_datetime) }}</span>
              </mat-list-item>
              <mat-list-item *ngIf="rental.return_location">
                <mat-icon matListItemIcon>place</mat-icon>
                <span matListItemTitle>Место возврата</span>
                <span matListItemLine>{{ rental.return_location }}</span>
              </mat-list-item>
              <mat-list-item *ngIf="rental.return_datetime">
                <mat-icon matListItemIcon>schedule</mat-icon>
                <span matListItemTitle>Дата/время возврата</span>
                <span matListItemLine>{{ formatDateTime(rental.return_datetime) }}</span>
              </mat-list-item>
              <mat-list-item *ngIf="rental.expected_return_datetime">
                <mat-icon matListItemIcon>event_available</mat-icon>
                <span matListItemTitle>Ожидаемая дата/время возврата</span>
                <span matListItemLine>{{ formatDateTime(rental.expected_return_datetime) }}</span>
              </mat-list-item>
              <mat-list-item *ngIf="rental.route">
                <mat-icon matListItemIcon>route</mat-icon>
                <span matListItemTitle>Маршрут</span>
                <span matListItemLine>{{ rental.route }}</span>
              </mat-list-item>
            </mat-list>

            <mat-divider *ngIf="rental.notes"></mat-divider>
            <div *ngIf="rental.notes" class="notes-section">
              <strong>Заметки:</strong>
              <p>{{ rental.notes }}</p>
            </div>
          </mat-card-content>
        </mat-card>

        <mat-card class="payments-card">
          <mat-card-content>
            <div class="payments-header">
              <mat-card-title>Платежи</mat-card-title>
              <button mat-raised-button color="primary" class="add-payment-btn"
                      [routerLink]="'/payments/new'" [queryParams]="{ rental: rental.id }">
                <mat-icon>add</mat-icon> Добавить платёж
              </button>
            </div>
            <div *ngIf="paymentsLoading" class="loading-inline">
              <mat-spinner diameter="32"></mat-spinner>
            </div>
            <p *ngIf="!paymentsLoading && payments.length === 0" class="empty-text">Нет платежей</p>
            <mat-list *ngIf="!paymentsLoading && payments.length > 0">
              <app-payment-card
                *ngFor="let p of payments"
                [payment]="p"
                (deleted)="onPaymentDeleted()" />
            </mat-list>
            <div *ngIf="!paymentsLoading && payments.length > 0 && paidPaymentsTotal > 0" class="payments-total">
              Итого оплачено: {{ paidPaymentsTotal }}&nbsp;&#8381;
            </div>
          </mat-card-content>
        </mat-card>

        <mat-card class="extra-services-card">
          <mat-card-content>
            <mat-card-title>Дополнительные услуги</mat-card-title>
            <p *ngIf="!rental.extra_services?.length" class="empty-text">Нет доп. услуг</p>
            <mat-list *ngIf="rental.extra_services?.length">
              <mat-list-item *ngFor="let es of rental.extra_services">
                <mat-icon matListItemIcon>add_circle</mat-icon>
                <span matListItemTitle>{{ es.name }}</span>
                <span matListItemLine>{{ es.amount | number:'1.0-2' }}&nbsp;&#8381;</span>
              </mat-list-item>
            </mat-list>
            <div *ngIf="rental.extra_services?.length" class="extra-services-total">
              Итого: {{ extraServicesTotal | number:'1.0-2' }}&nbsp;&#8381;
            </div>
          </mat-card-content>
        </mat-card>

        <mat-card class="summary-card">
          <mat-card-content>
            <mat-card-title>Итоги проката</mat-card-title>
            <mat-list>
              <mat-list-item>
                <mat-icon matListItemIcon>local_gas_station</mat-icon>
                <span matListItemTitle>Уровень топлива при выдаче, км</span>
                <span matListItemLine>{{ rental.fuel_level_before ?? '—' }}</span>
              </mat-list-item>
              <mat-list-item>
                <mat-icon matListItemIcon>local_gas_station</mat-icon>
                <span matListItemTitle>Уровень топлива при возврате, км</span>
                <span matListItemLine>{{ rental.fuel_level_after ?? '—' }}</span>
              </mat-list-item>
              <mat-list-item>
                <mat-icon matListItemIcon>local_gas_station</mat-icon>
                <span matListItemTitle>Расход топлива, км</span>
                <span matListItemLine>{{ rental.fuel_consumed ?? '—' }}</span>
              </mat-list-item>
              <mat-list-item>
                <mat-icon matListItemIcon>speed</mat-icon>
                <span matListItemTitle>Пробег при выдаче, км</span>
                <span matListItemLine>{{ rental.mileage_before }}</span>
              </mat-list-item>
              <mat-list-item>
                <mat-icon matListItemIcon>speed</mat-icon>
                <span matListItemTitle>Пробег при возврате, км</span>
                <span matListItemLine>{{ rental.mileage_after !== null ? (rental.mileage_after) : '—' }}</span>
              </mat-list-item>
              <mat-list-item>
                <mat-icon matListItemIcon>route</mat-icon>
                <span matListItemTitle>Пройдено, км</span>
                <span matListItemLine>{{ rental.distance ?? '—' }}</span>
              </mat-list-item>
              <mat-list-item>
                <mat-icon matListItemIcon>speed</mat-icon>
                <span matListItemTitle>Перепробег, км</span>
                <span matListItemLine>
                  {{ rental.mileage_overrun ?? '—' }}
                  <ng-container *ngIf="rental.car_mileage_limit !== null && rental.car_mileage_limit !== undefined">
                    <span class="limit-note">(Лимит: {{ rental.car_mileage_limit }} км/сутки)</span>
                  </ng-container>
                </span>
              </mat-list-item>
            </mat-list>
          </mat-card-content>
        </mat-card>

        <mat-card class="gallery-card" *ngIf="rental.images_before?.length">
          <mat-card-content>
            <mat-card-title>Фото до проката</mat-card-title>
            <div class="image-grid">
              <div
                *ngFor="let img of rental.images_before; let i = index"
                class="image-grid__item"
                (click)="openImage(img)"
                (keydown.enter)="openImage(img)"
                tabindex="0"
                role="button"
                [attr.aria-label]="'Фото до проката ' + (i + 1)">
                <img [src]="img.preview" [alt]="img.title || ('Фото ' + (i + 1))" class="image-grid__thumb" />
              </div>
            </div>
          </mat-card-content>
        </mat-card>

        <mat-card class="gallery-card" *ngIf="rental.images_after?.length">
          <mat-card-content>
            <mat-card-title>Фото после проката</mat-card-title>
            <div class="image-grid">
              <div
                *ngFor="let img of rental.images_after; let i = index"
                class="image-grid__item"
                (click)="openImage(img)"
                (keydown.enter)="openImage(img)"
                tabindex="0"
                role="button"
                [attr.aria-label]="'Фото после проката ' + (i + 1)">
                <img [src]="img.preview" [alt]="img.title || ('Фото ' + (i + 1))" class="image-grid__thumb" />
              </div>
            </div>
          </mat-card-content>
        </mat-card>

        <div class="actions">
          <button mat-stroked-button [routerLink]="['/rentals', rental.id, 'edit']" class="full-width-btn">
            <mat-icon>edit</mat-icon> Редактировать прокат
          </button>
          <button mat-raised-button color="accent" class="full-width-btn"
                  [routerLink]="['/rentals', rental.id, 'return']"
                  *ngIf="rental.status === RentalStatus.ISSUED">
            <mat-icon>assignment_return</mat-icon> Принять автомобиль
          </button>
          <button mat-stroked-button [routerLink]="['/rentals', rental.id, 'report']" class="full-width-btn">
            <mat-icon>description</mat-icon> Отчёт для мессенджера
          </button>
          <button mat-stroked-button [routerLink]="['/bookings', rental.booking_id]" class="full-width-btn"
                  *ngIf="rental.booking_id">
            <mat-icon>event_note</mat-icon> Перейти к бронированию
          </button>
          <button mat-stroked-button color="warn" class="full-width-btn" (click)="deleteRental()">
            <mat-icon>delete</mat-icon> Удалить
          </button>
        </div>
      </div>
    </div>

    <ng-template #spinner>
      <div class="loading-container"><mat-spinner diameter="40"></mat-spinner></div>
    </ng-template>
  
